/* global window */

// eslint-disable-next-line import/no-cycle
import Item from 'common/components/item/Item';
import { getMessage } from 'common/helpers/miscHelper';

import CartErrors from './CartErrors';
import CartSummary from './CartSummary';
import CouponsAndPromos from './CouponsAndPromos';

const CartDisplay = (props) => {
  const { cart, settings } = props;
  const redirectToStoreFront = (e) => {
    e.preventDefault();
    window.location.href = settings.data.continueShopping;
  };
  if (!cart.items || cart.items.length === 0) {
    return (
      <div
        className="c7-message--empty-cart"
        dangerouslySetInnerHTML={{
          __html: getMessage('Empty Cart', settings)
        }}
        onClick={redirectToStoreFront}
      />
    );
  }
  return (
    <>
      <CartErrors cart={cart} />
      <div className="c7-cart-items">
        {cart.items.map((item) => (
          <Item item={item} key={item.id} settings={settings} />
        ))}
      </div>
      <CartSummary cart={cart} settings={settings} />
      <CouponsAndPromos cart={cart} settings={settings} />
    </>
  );
};

export default CartDisplay;
